import {Component} from '@angular/core';
import {IonicPage, NavParams, ViewController} from 'ionic-angular';
import {TextServiceProvider} from "../../../../core/services/text-service/text-service";
import {UserTask} from "../../../interfaces/user-task.interface";
import { UserTaskType, valueOfUserTaskType } from '../../../interfaces/user-task-type.enum';

@IonicPage()
@Component({
  selector: 'user-task-info',
  templateUrl: 'user-task-info.html',
})
export class UserTaskInfoPage {

  public userTask: UserTask;
  public taskType;

  public name: string;
  public description: string;
  public createdDate: string;
  public assignee: string;
  public dueDate: string;
  public closedDate: string;
  public taskTypeDisplayName: string;
  public startedBy: string;

  constructor(
    private navParams: NavParams,
    public textService: TextServiceProvider,
    private viewCtrl: ViewController
  ) {}

  ionViewWillEnter() {
    this.userTask = this.navParams.get('userTask');
    this.taskType = this.navParams.get('taskType');

    this.name = this.userTask.name;
    this.description = this.userTask.description;
    this.createdDate = this.userTask.createdDate.toString();
    this.assignee = this.userTask.assignee;
    this.dueDate = (!!this.userTask.dueDate)? this.userTask.dueDate.toString() : '';
    this.closedDate = (!!this.userTask.closedDate)? this.userTask.closedDate.toString(): '';
    this.taskTypeDisplayName = valueOfUserTaskType(this.taskType);
    this.startedBy = this.userTask.startUserId;
  }

  close() {
    this.viewCtrl.dismiss().catch((err) => console.error(err));
  }
}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-task-preview/info/user-task-info.ts